import React from 'react'

const NoMatch = () => {
  return (
    <div>No Route Found</div>
  )
}

export default NoMatch